<template>
  <v-container>
    <v-stepper
      class="elevation-0 transparent show-overflow"
      alt-labels
      :value="value"
      @change="$emit('input', $event)"
    >
      <v-stepper-header class="no-top elevation-0 white half-radius">
        <template v-for="(content, index) in steps">
          <v-stepper-step
            :id="index"
            :class="{
              passed: value > index,
              current: value === index,
              pending: value < index,
              'hover transform': index <= maxStep,
            }"
            color="#FF347C"
            :key="content.key + index"
            :complete="value > index"
            complete-icon="mdi-checkbox-marked-circle"
            step
            class="my-auto"
            v-ripple="true"
            @click="travel(index)"
            >{{ content.stepTitle || content.key }}</v-stepper-step
          >
          <v-divider
            v-if="index < steps.length - 1"
            :key="index"
            class="custom-divider"
            :class="{
              'stepper-margin': value === 0,
              'custom-divider-passed': value > index,
              'custom-divider-pending': value <= index,
            }"
          ></v-divider>
        </template>
      </v-stepper-header>
      <v-divider class="mt-5 wider" />
      <v-stepper-items class="show-overflow pa-0">
        <v-stepper-content
          v-for="(content, index) in steps"
          :key="content.key + index"
          :step="index"
          class="pa-0"
        >
          <component :is="content.key" @next-step="onNextStep" @prev-step="onPrevStep"></component>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>
<script>
/* eslint-disable no-console */
export default {
  props: {
    value: {
      required: true,
      type: Number,
    },
    steps: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      maxStep: 0,
      selectedComponent: "Vocabulary",
      componentDefinition: {
        Vocabulary: "Stepper/Vocabulary",
        Grammar: "Stepper/Grammar",
        "Custom HW": "Stepper/Conclusion",
        Listening: "Stepper/AudioText",
        " Pronunciation ": "Stepper/AudioTranscript",
        Speaking: "Stepper/Speaking",
        Homework: "Stepper/Homework",
        "Transcript ": "Stepper/Audio Transcript",
        Pronunciation: "Stepper/Pronunciation",
      },
    };
  },
  methods: {
    appendCircle() {
      let item = document.getElementById(String(this.value));
      let circle = document.createElement("div");
      circle.className += "personalized-circle-stepper";
      item.children[0].appendChild(circle);
    },
    onNextStep() {
      this.$emit("input", this.value + 1);
    },
    onPrevStep() {
      this.$emit("input", this.value - 1);
    },
    travel(index) {
      this.$emit("input", index);
    },
  },
  watch: {
    value() {
      if (this.value > this.maxStep) {
        this.maxStep = this.value;
      }
      let oldItem = document.querySelector(".personalized-circle-stepper");
      if (oldItem) oldItem.remove();
      this.appendCircle();
    },
  },
  mounted() {
    this.appendCircle();
  },
  created() {
    for (let c = 0; c < this.steps.length; c++) {
      const element = this.steps[c].key;
      this.$options.components[element] = () =>
        import(`./${this.componentDefinition[element]}.vue`);
    }
  },
};
</script>
<style>
div.passed span.v-stepper__step__step {
  width: 24px;
  height: 24px;
}
.v-stepper__label {
  position: absolute;
  text-align: center !important;
  margin-top: 25px;
}
div.passed .v-stepper__label {
  margin-top: 35px;
}
div.pending span.v-stepper__step__step {
  background-color: #ff2e7b !important;
  min-width: 10px !important;
  width: 10px !important;
  height: 10px !important;
}
.personalized-circle-stepper {
  width: 10px;
  height: 10px;
  background-color: white;
  border-radius: 50%;
}
div.current span.v-stepper__step__step {
  background-color: #ff2e7b !important;
  min-width: 18px !important;
  width: 18px !important;
  height: 18px !important;
}
.v-icon.mdi-checkbox-marked-circle {
  font-size: 14px !important;
}
.stepper-margin {
  margin-top: 32px !important;
}
.custom-divider {
  transition: all 0.2s linear;
}
.custom-divider-passed {
  margin-right: -84px !important;
  margin-left: -84px !important;
  border-top: 2px solid #ff2e7b !important;
}
.custom-divider-current {
  margin-right: -84px !important;
  margin-left: -84px !important;
}
.custom-divider-pending {
  border-top-width: 2px !important;
  margin-right: -84px !important;
  margin-left: -84px !important;
}
.show-overflow {
  overflow: visible !important;
}
.v-stepper__wrapper {
  overflow: visible !important;
}
.no-top {
  margin-top: -3%;
}
.transform:hover {
  transform: scale(1.15);
  transition: all 0.2s ease-in-out;
}
</style>
